// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"home_productcontent__76vWG"};